import { useEffect, useState } from 'react'
import docciergeLogo from '../../assets/images/logos/doccierge.svg'
import docciergeShape from '../../assets/images/logos/doccierge-shape.svg'
import scrollToAnchor from '../../utils/scrollToAnchor'

import './_Header.scss'

const Header = () => {
  const [ navOpen, setNavOpen ] = useState(false)
  const [fixed, setFixed ] = useState(false)

  const fixHeader = () => {
    if (window.scrollY > 0 && !fixed) {
      setFixed(true)
    } else if (window.scrollY === 0 && fixed) {
      setFixed(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', fixHeader)

    return () => window.addEventListener('scroll', fixHeader)
  })

  const toggleNav = () => setNavOpen(!navOpen)

  return (
    <header className={`Header section-padding ${fixed ? 'fixed' : ''}`}>
      <div className='container'>
        <div className='logo-box'>
          <button onClick={() => scrollToAnchor('')}>
            <img src={docciergeLogo} alt='Doccierge' className='logo' />
          </button>
        </div>
        <div className='nav-links-box'>
          <ul className='nav-links'>
            <li className='nav-link'>
              <button onClick={() => scrollToAnchor('services')} className='link'>Services</button>
              </li>
            <li className='nav-link'>
              <button onClick={() => scrollToAnchor('features')} className='link'>Features</button>
              </li>
            <li className='nav-link'>
              <button onClick={() => scrollToAnchor('doctors')} className='link'>Doctors</button>
              </li>
            <li className='nav-link'>
              <button onClick={() => scrollToAnchor('review')} className='link'>Review</button>
              </li>
            <li className='nav-link'>
              <button onClick={() => scrollToAnchor('location')} className='link'>Location</button>
            </li>
          </ul>
        </div>
        <button className='burger-button' onClick={toggleNav}>
          <svg width='20' height='14' viewBox='0 0 20 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <rect width='20' height='2' rx='1' fill='white'/>
            <rect y='6' width='20' height='2' rx='1' fill='white'/>
            <rect y='12' width='20' height='2' rx='1' fill='white'/>
          </svg>
        </button>
      </div>
      <div className={`body-overlay ${navOpen ? 'open' : ''}`}></div>
      <div className={`mobile-nav ${navOpen ? 'open' : ''}`}>
        <div className='logo-box'>
          <img src={docciergeShape} alt='Doccierge' className='logo' />
          <button className='close-icon' onClick={toggleNav}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.756 6.25237C16.4306 5.927 15.905 5.927 15.5796 6.25237L11.5 10.3237L7.42036 6.24403C7.09499 5.91866 6.5694 5.91866 6.24403 6.24403C5.91866 6.5694 5.91866 7.09499 6.24403 7.42036L10.3237 11.5L6.24403 15.5796C5.91866 15.905 5.91866 16.4306 6.24403 16.756C6.5694 17.0813 7.09499 17.0813 7.42036 16.756L11.5 12.6763L15.5796 16.756C15.905 17.0813 16.4306 17.0813 16.756 16.756C17.0813 16.4306 17.0813 15.905 16.756 15.5796L12.6763 11.5L16.756 7.42036C17.073 7.10334 17.073 6.5694 16.756 6.25237V6.25237Z" fill="#92A8BD"/>
            </svg>
          </button>
        </div>
        <ul className='nav-links'>
          <li className='nav-link'>
            <button onClick={() => scrollToAnchor('services')} className='link'>Services</button>
            </li>
          <li className='nav-link'>
            <button onClick={() => scrollToAnchor('features')} className='link'>Features</button>
            </li>
          <li className='nav-link'>
            <button onClick={() => scrollToAnchor('doctors')} className='link'>Doctors</button>
            </li>
          <li className='nav-link'>
            <button onClick={() => scrollToAnchor('review')} className='link'>Review</button>
            </li>
          <li className='nav-link'>
            <button onClick={() => scrollToAnchor('location')} className='link'>Location</button>
            </li>
        </ul>
      </div>
    </header>
  )
}

export default Header
